import { renderList as _renderList, Fragment as _Fragment, openBlock as _openBlock, createElementBlock as _createElementBlock, createElementVNode as _createElementVNode, toDisplayString as _toDisplayString, withModifiers as _withModifiers, createCommentVNode as _createCommentVNode, vShow as _vShow, withDirectives as _withDirectives, pushScopeId as _pushScopeId, popScopeId as _popScopeId } from "vue"
import _imports_0 from '@/assets/icons/x-circle.svg'


const _withScopeId = n => (_pushScopeId("data-v-5304771c"),n=n(),_popScopeId(),n)
const _hoisted_1 = { class: "container" }
const _hoisted_2 = { class: "file-info-wrapper" }
const _hoisted_3 = ["src"]
const _hoisted_4 = ["onClick"]
const _hoisted_5 = {
  key: 1,
  class: "file-input-wrapper"
}
const _hoisted_6 = ["for"]
const _hoisted_7 = { class: "placeholder" }
const _hoisted_8 = ["name", "accept", "id", "multiple"]

export function render(_ctx: any,_cache: any,$props: any,$setup: any,$data: any,$options: any) {
  return (_openBlock(), _createElementBlock("div", _hoisted_1, [
    ($setup.inputFileList.length)
      ? (_openBlock(true), _createElementBlock(_Fragment, { key: 0 }, _renderList($setup.inputFileList, (file, index) => {
          return (_openBlock(), _createElementBlock("div", {
            key: index,
            class: "file"
          }, [
            _createElementVNode("div", _hoisted_2, [
              _createElementVNode("img", {
                class: "img-file",
                src: $setup.getImageThumbnailUrl(file, index),
                alt: "파일 미리보기"
              }, null, 8 /* PROPS */, _hoisted_3),
              _createElementVNode("p", null, _toDisplayString(file.name), 1 /* TEXT */)
            ]),
            _createElementVNode("img", {
              class: "img-clear-text",
              src: _imports_0,
              onClick: _withModifiers(($event: any) => ($setup.deleteFile(index)), ["stop"]),
              onMousedown: _cache[0] || (_cache[0] = _withModifiers(() => {}, ["prevent"])),
              alt: "파일삭제",
              role: "button"
            }, null, 40 /* PROPS, NEED_HYDRATION */, _hoisted_4)
          ]))
        }), 128 /* KEYED_FRAGMENT */))
      : _createCommentVNode("v-if", true),
    ($setup.inputFileList.length < $props.maxFiles)
      ? (_openBlock(), _createElementBlock("div", _hoisted_5, [
          _createElementVNode("label", {
            class: "file-input-label",
            for: `file-input-${$props.fileInputUid}`
          }, [
            _createElementVNode("div", _hoisted_7, [
              _createElementVNode("p", null, _toDisplayString($props.placeHolder), 1 /* TEXT */)
            ])
          ], 8 /* PROPS */, _hoisted_6),
          _withDirectives(_createElementVNode("input", {
            ref: "fileInput",
            name: $props.name,
            type: "file",
            accept: $props.accept,
            id: `file-input-${$props.fileInputUid}`,
            multiple: $props.maxFiles > 1,
            onChange: $setup.onAddedFiles
          }, null, 40 /* PROPS, NEED_HYDRATION */, _hoisted_8), [
            [_vShow, false]
          ])
        ]))
      : _createCommentVNode("v-if", true)
  ]))
}